import { PropsWithChildren, JSX } from 'react';
import classNames from 'classnames';
import { FeatureLabelTheme } from './enums/FeatureLabelTheme';
import classes from './FeatureLabel.module.scss';

interface IProps {
    className?: string;
    dataQa?: string;
    theme?: FeatureLabelTheme;
}

export const FeatureLabel = ({
    theme = FeatureLabelTheme.NEUTRAL,
    ...props
}: PropsWithChildren<IProps>): JSX.Element => (
    <div
        className={classNames(classes.label, classes[theme], props.className)}
        data-qa={props.dataQa}
    >
        {props.children}
    </div>
);
